export default {
  name: 'routeBackMixin',
  methods: {
    $back () {
      this.$router.back()
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/back.js